import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit } from '@angular/core';
import { IAvatar } from '@core/models';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvatarComponent implements OnInit, OnChanges {
  @Input() avatar!: IAvatar | null;
  @Input() styleClass!: string;

  isRound!: boolean | undefined;
  showInitials = false;
  hasImageLoadError = false;

  initials!: string;
  accessibleName = '';
  randomBgColor: string | undefined;

  constructor() {}

  ngOnInit() {
    this.randomBgColor = `random-color-${Math.floor(Math.random() * 6) + 1}`;
  }

  ngOnChanges(): void {
    this.hasImageLoadError = false;

    if (!this.avatar) {
      this.initials = '';
      this.accessibleName = '';
      this.showInitials = true;
      return;
    }

    const firstName = this.avatar.firstName?.trim() || '';
    const lastName = this.avatar.lastName?.trim() || '';
    this.initials = `${firstName.substring(0, 1)}${lastName.substring(0, 1)}`.toLocaleUpperCase();
    this.accessibleName = `${firstName} ${lastName}`.trim();
    this.showInitials = !this.avatar.url;
  }

  onImageLoadError(): void {
    this.hasImageLoadError = true;
    this.showInitials = true;
  }
}
